module.exports = __webpack_public_path__ + "img/iconoEmpresa.daa65078.png";